// extracted by mini-css-extract-plugin
export default {"searchBlock":"search_searchBlock__CqXCO","search":"search_search__O9jq5","input":"search_input__OU007","close":"search_close__aOqih"};